// @ts-nocheck
import { useEffect, useState } from 'react';
// material
import { Grid, Container, Stack, Typography, TextField, Button, Pagination, Card, CardContent } from '@mui/material';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// components
import Page from '../../components/Page';
import { ProductSort, ProductList, ProductCartWidget, ProductFilterSidebar } from '../sections/@dashboard/products';
import { SpacePostCard, SpacePostsSort } from '../../sections/@dashboard/revenue';
import { SpacePostsSearch } from '../../sections/@dashboard/parkings';
// mock
import POSTS from '../../_mock/space';
import { useGetRevenueDataMutation } from '../../store/api/revenueApi';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setRevenue, getRevenue, getRevenueTotalPages } from '../../store/state/revenueSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { DatePicker, LocalizationProvider, StaticDatePicker } from '@mui/lab';
import { Formik } from 'formik';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import {
  checkPermissions,
  getEndDate,
  getStartDate,
  GET_REVENUE_TABDATA,
} from '../../sections/@dashboard/parkingspaces/utility';
import Loading from '../../components/Loading';
import { styled } from '@mui/material/styles';
import toast from 'react-hot-toast';
import { PERMISSION } from '../../utils/userPermission';

// ----------------------------------------------------------------------
const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

let day1 = new Date();

let day7 = moment().startOf('week').toDate();
let day30 = moment().endOf('week').toDate();
day30 = day30.toISOString();

export default function AdminRevenue() {
  const dispatch = useAppDispatch();
  const [revenues, setRevenues] = useState([]);
  const token = JSON.parse(localStorage.getItem('login') || '{}');
  const [getRevenueData, revenueResponse] = useGetRevenueDataMutation();
  const revenueData = useAppSelector(getRevenue);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [value, setValue] = useState(0);
  const [getDay, setGetDay] = useState();
  const [endDay, setEndDay] = useState();
  const isUserNotFound = revenues.length === 0;
  const totalPages = useAppSelector(getRevenueTotalPages);
  const parkingsPerPage = 5;
  const isRevenueNotAvailable = revenues.length === 0;

  useEffect(() => {
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[value]),
        toDate: getEndDate(GET_REVENUE_TABDATA[value]),
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  }, []);

  const getRevenueDataAsync = async (page, parkingPerPage, searchTerm = '') => {
    await getRevenueData({
      token: token.token,
      payload: {
        page: page,
        offset: parkingPerPage,
        fromDate: getStartDate(GET_REVENUE_TABDATA[value]),
        toDate: getEndDate(GET_REVENUE_TABDATA[value]),
        searchValue: searchTerm,
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  };

  useEffect(() => {
    if (revenueResponse.isSuccess) {
      dispatch(setRevenue(revenueResponse.data.revenueData));
      if (revenueResponse.data?.totalRecords == 0) {
        toast.success('No data available');
      }
    }
    if (revenueResponse.isError) {
      let errorData: any = revenueResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [revenueResponse.isSuccess, revenueResponse.isError]);

  useEffect(() => {
    if (revenueData) {
      setRevenues(revenueData);
    }
  }, [revenueData]);

  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  const [searchTerm, setSearchTerm] = useState('');
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setGetDay(getStartDate(GET_REVENUE_TABDATA[newValue]));
    setEndDay(getEndDate(GET_REVENUE_TABDATA[newValue]));
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[newValue]),
        toDate: getEndDate(GET_REVENUE_TABDATA[newValue]),
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  };

  const handleSearchTerm = (event) => {
    setPage(0);
    setSearchTerm(event.target.value);
    getRevenueDataAsync(page, parkingsPerPage, event.target.value);
  };

  const handelDatePicker = (values: any) => {
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getDay === undefined ? getStartDate(GET_REVENUE_TABDATA[0]) : getDay,
        toDate: endDay === undefined ? getEndDate(GET_REVENUE_TABDATA[0]) : endDay,
        isDisputed: false,
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  };

  const handlePagination = (pages: number) => {
    setPage(pages - 1);
    getRevenueDataAsync(pages - 1, rowsPerPage);
  };

  return (
    <Page title="Revenue Overview">
      {checkPermissions(PERMISSION.REVENUE_ALL, token.permissions) ? (
        <Container>
          <Typography variant="h4" mb={3}>
            Revenue Overview
          </Typography>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={3} style={{ width: '100%' }}>
              <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
                <LinkTab label="Today" />
                <LinkTab label="This Week" />
                <LinkTab label="This Month" />
              </Tabs>
            </Stack>
          </Box>
            <Stack mb={5} direction="row" alignItems="center" justifyContent="space-between" className="search">
              <SpacePostsSearch
                value={searchTerm}
                posts={revenues}
                handleSearchTerm={handleSearchTerm}
                placeholder={'Search Vendor Name'}
              />

              <Formik initialValues={''} onSubmit={handelDatePicker}>
                {({ handleBlur, handleChange, handleSubmit, setFieldValue, values }) => (
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginLeft: '30px',
                    }}
                    className="datepicker"
                  >
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="From Date"
                        value={getDay}
                        onChange={(event: any) => {
                          setGetDay(event);
                        }}
                        renderInput={(params) => (
                          <TextField
                            id="fromDates"
                            name="fromDates"
                            style={{
                              width: '35%',
                              borderColor: 'blue',
                            }}
                            className="datepickerone"
                            onBlur={handleBlur}
                            onChange={(event: any) => {
                              setGetDay(event.target.value);
                            }}
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To Date"
                        value={endDay}
                        onChange={(event: any) => {
                          setEndDay(event);
                        }}
                        renderInput={(params) => (
                          <TextField
                            id="toDates"
                            name="toDates"
                            style={{
                              width: '35%',
                              borderColor: 'blue',
                            }}
                            className="datepickertwo"
                            onBlur={handleBlur}
                            onChange={(event: any) => {
                              setEndDay(event.target.value);
                            }}
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    <Stack>
                      <Button
                        style={{
                          width: '100%',
                          borderColor: 'blue',
                          padding: '10px',
                          marginLeft: '10px',
                          alignItems: 'center',
                          color: 'white',
                          backgroundColor: '#E23744',
                        }}
                        className="submitbutton"
                        onClick={() => {
                          handleSubmit();
                        }}
                        variant="contained"
                      >
                        Submit
                      </Button>
                    </Stack>
                  </Box>
                )}
              </Formik>
            </Stack>

          <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            {Array.from(revenues).map((revenue, index) => (
              <SpacePostCard key={revenue.id} post={revenue} />
            ))}
          </Grid>

          <Grid container spacing={3} marginBottom="20px" marginTop="20px">
            {isRevenueNotAvailable && (
              <Box display="contents" justifyContent="center" height="10px" alignItems="center">
                <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
                  <Card sx={{ width: 1, marginTop: 5 }}>
                    <CardContent>
                      <Typography gutterBottom align="center" variant="subtitle1">
                        Revenue not available !!!{' '}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Box>
            )}
          </Grid>

          {!isUserNotFound && !isRevenueNotAvailable && (
            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <Pagination count={totalPages} siblingCount={0} size={'large'} onChange={handlePagination} />
            </Box>
          )}
        </Container>
      ) : null}
      {revenueResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
